import styled, { createGlobalStyle } from 'styled-components';
import { PopoverGlobalStyleMixin } from '../../mixins/components/PopoverGlobalStyleMixin';
import { PopoverMixin } from '../../mixins/components/PopoverMixin';
import { Modal } from '../Modal/Modal';
export var StyledPopover = /*#__PURE__*/styled(Modal).withConfig({
  displayName: "StyledPopover",
  componentId: "c11n-8-111-1__sc-paejr5-0"
})(["", ""], PopoverMixin);
export var PopoverGlobalStyle = /*#__PURE__*/createGlobalStyle(["", ""], PopoverGlobalStyleMixin);